import type { IPaymentMethodsList } from "../types/constants";
import { DEFAULT_PAYMENT_METHOD, PAYMENT_METHODS_LIST } from "../constants/payment-methods-list";

export const getPaymentMethod = (searchString: string): IPaymentMethodsList => {
  for (const [key, value] of PAYMENT_METHODS_LIST) {
    if (typeof key === 'string' ? (key === searchString) : key.includes(searchString)) {
      return value;
    }
  };

  return {
    ...DEFAULT_PAYMENT_METHOD,
    name: searchString,
    nameAr: searchString,
  };
};